import {
  CreateSurvey,
  Survey,
  SurveyQuestion,
  SurveyQuestionOption,
	SurveyQuestionType,
} from "../types/working-model";
import { Get, Put, Post } from "./helpers";

export function GetSurveys(token: string): Promise<Survey[]> {
  return Get("/v3/admin/channel/surveys", token);
}

export function InsertSurvey(
  token: string,
  survey: CreateSurvey
): Promise<Survey> {
  return Post("/v3/admin/channel/surveys", token, { survey });
}

export function UpdateSurvey(token: string, survey: Survey): Promise<Survey> {
  return Put("/v3/admin/channel/surveys", token, { survey }, true);
}

export function GetNewQuestion(token: string): Promise<SurveyQuestion> {
  return Post("/v3/admin/channel/surveys/question", token, {});
}

export function GetNewOption(token: string): Promise<SurveyQuestionOption> {
  return Post("/v3/admin/channel/surveys/question/option", token, {});
}

export function GetQuestionStats(session: number, question: number, question_type: SurveyQuestionType): Promise<{counts: {[key: string]: number}, total: number}> {
	return Get(`/v3/admin/events/surveys/question-stats/${session}/${question}/${question_type}`, "");
}